import { FC, SVGProps } from "react";
import { ActionIcons } from "./icons";

export type ActionType = keyof typeof ActionIcons;

export type ButtonVariant =
  | "primary"
  | "download"
  | "outline"
  | "like"
  | "dislike";

export interface ActionConfig {
  type: ActionType;
  label: string;
  onClick: () => void;
  variant?: ButtonVariant;
  IconComponent?: React.FC<React.SVGProps<SVGSVGElement>>;
  isActive?: boolean;
}

export interface CommonActionBarProps {
  leftActions: ActionConfig[];
  rightActions: ActionConfig[];
}

// 각 ActionType별 기본 스타일 설정
export const DEFAULT_ACTION_STYLES: Record<
  ActionType,
  { variant: ButtonVariant; IconComponent: FC<SVGProps<SVGSVGElement>> }
> = {
  copy: {
    variant: "primary",
    IconComponent: ActionIcons.copy,
  },
  share: {
    variant: "primary",
    IconComponent: ActionIcons.share,
  },
  edit: {
    variant: "primary",
    IconComponent: ActionIcons.edit,
  },
  download: {
    variant: "download",
    IconComponent: ActionIcons.download,
  },
  like: {
    variant: "like",
    IconComponent: ActionIcons.like,
  },
  dislike: {
    variant: "dislike",
    IconComponent: ActionIcons.dislike,
  },
};
